/* eslint-disable */
import matchHeight from "jquery-match-height";
import $ from "jquery";
export var MatchHeightInit = function () {
    $(document).ready(function () {
        $(".address-box").matchHeight();
    });
};
